import React, { useEffect } from "react";
import { ConnectedProps } from "react-redux";
import { useParams } from "react-router-dom";

import AddEditForm from "../AddEditForm";
import connector from "./Container";

const EditInsurance = ({
  state,
  actions,
}: ConnectedProps<typeof connector>) => {
  return <AddEditForm isAdd={false} actions={actions} state={state} />;
};

export default EditInsurance;
